var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module cercaliagl/control/FullScreen
*/
import maplibregl from 'maplibre-gl';
import Control from './Control';
import MapControls from './MapControls';
import { i18n } from '../dictionary';
import VControlButton from '../view/VControlButton';
/**
 * @classdesc
 * <b>Javascript ES5</b>
 * ```js
 * const control = new cercaliagl.control.FullScreem();
 * map.addControl(control);
 * ```
 * <br/>
 * Class <b/>cercaliagl.control.FullScreen<b> is used for internal purposes, but can be accessed throught methods.
 *
 * Usage getting full screen control from map:
 *
 * ```js
 * const map = new cercaliagl.Map({ target: 'map' });
 * const fullScreen = map.getControlByName(cercaliagl.control.MapControls.FULLSCREEN);
 * fullScreen.isEnable()
 * ```
 *
 * @extends {Control}
 * @api
 */
var FullScreen = /** @class */ (function (_super) {
    __extends(FullScreen, _super);
    /**
     * @constructor
     */
    function FullScreen() {
        var _this = this;
        var controlButton = new VControlButton('fullscreen');
        var element = controlButton.getElement();
        _this = _super.call(this, {
            element: element,
            name: MapControls.FULLSCREEN,
            className: 'cercaliagl.control.FullScreen',
        }) || this;
        /**
         * @private
         * @type {VControlButton}
         */
        _this.controlButton_ = controlButton;
        /**
         * @private
         * @type {maplibregl.FullscreenControl}
         */
        _this.fullScreenControl_ = new maplibregl.FullscreenControl({ onAdd: _this.onAdd });
        /**
         * @private
         * @type {HTMLElement}
         */
        _this.element_ = element;
        /**
         * @private
         * @type {boolean}
         */
        _this.enabled = false;
        _this.initialize_();
        return _this;
    }
    /**
     * @override
     * @param {import("maplibre-gl").Map} map Mapbox map
     */
    FullScreen.prototype.onAdd = function (map) {
        this.map_ = map;
        this.fullScreenControl_.onAdd(map);
        return this.element_;
    };
    /**
     * @private
     */
    FullScreen.prototype.initialize_ = function () {
        this.controlButton_.setTooltip(i18n('fullScreen'));
        this.element_.addEventListener('click', this.handleClick_.bind(this));
    };
    /**
     * @private
     */
    FullScreen.prototype.handleClick_ = function () {
        this.fullScreenControl_._onClickFullscreen();
        this.enabled = !this.enabled;
    };
    /**
    * @return {boolean} Is fullscreen enabled
     * @api
     */
    FullScreen.prototype.isEnabled = function () {
        return this.enabled;
    };
    /**
     * Toggle fullscreen
     * @api
     */
    FullScreen.prototype.toggle = function () {
        this.handleClick_();
    };
    return FullScreen;
}(Control));
export default FullScreen;
//# sourceMappingURL=FullScreen.js.map